import i18n from 'config/i18n';
import * as yup from 'yup';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale());

const schema = yup.object({
  name: yup.string().required(
    t('validationFieldRequired', {
      name: t('adminPortal.resources.name')
    })
  ),
  code: yup.string().required(
    t('validationFieldRequired', {
      name: t('adminPortal.resources.code')
    })
  ),
  descriptions: yup.string(),
  checkOverlap: yup.boolean().default(false)
});

export default schema;
